module.exports = __webpack_public_path__ + "img/167.a8296ddc.svg";